import { useStyles } from './loader.style'

export const Loader = function ({ className = '', style = {} }) {
  const classes = useStyles()
  return (
    <div className={`${classes.container} ${className}`} style={style}>
      <div className={classes.rectangle1}></div>
      <div className={classes.rectangle2}></div>
      <div className={classes.rectangle3}></div>
      <div className={classes.rectangle4}></div>
      <div className={classes.rectangle5}></div>
    </div>
  )
}
